import AbstractService from "./AbstractService";
import FeatureFlagService from "./FeatureFlagService";
import NexusService from "./NexusService";

export default class AutoAssignmentLogService extends AbstractService {
	static autoAssignmentsApi = NexusService.autoAssignmentsApi;

	static apiCoreEndpointsFeature = "use_api_core_endpoints_auto_assignment_logs";

	static getAll(queryParams) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const payload = {};

			if (Object.hasOwn(queryParams, "organizationId")) {
				payload.organizationId = queryParams.organizationId;
			}

			if (Object.hasOwn(queryParams, "jobEventId")) {
				payload.jobEventId = queryParams.jobEventId;
			}

			if (Object.hasOwn(queryParams, "jobEventRecurrenceRuleId")) {
				payload.jobEventRecurrenceRuleId = queryParams.jobEventRecurrenceRuleId;
			}

			if (Object.hasOwn(queryParams, "jobEventStartDateTime")) {
				payload.jobEventStartDateTime = new Date(queryParams.jobEventStartDateTime);
			}

			if (Object.hasOwn(queryParams, "jobEventEndDateTime")) {
				payload.jobEventEndDateTime = new Date(queryParams.jobEventEndDateTime);
			}

			return this.autoAssignmentsApi
				.getAutoAssignmentLogs(payload)
				.then(response => ({ data: response }));
		}

		return this.get({
			endpoint: "autoassignmentlogs",
			queryParams,
		});
	}
}
